/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'image': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 0a7 7 0 00-7 7v18a7 7 0 007 7h18a7 7 0 007-7v-3.373V7a7 7 0 00-7-7H7zm23 19.21V7a5 5 0 00-5-5H7a5 5 0 00-5 5v12.21l5.806-5.806c1.02-.982 2.23-1.535 3.506-1.535 1.277 0 2.486.554 3.506 1.535l.014.014 4.918 4.918 1.181-1.182c1.02-.982 2.23-1.535 3.506-1.535 1.276 0 2.486.554 3.506 1.535l.014.014L30 19.21zm-10.956 1.248l3.749 3.749a1 1 0 001.414-1.414l-3.043-3.043 1.161-1.16c.718-.69 1.448-.971 2.113-.971.664 0 1.394.282 2.112.97L30 22.04V25a5 5 0 01-5 5H7a5 5 0 01-5-5v-2.96l7.2-7.2c.718-.69 1.448-.971 2.113-.971.664 0 1.394.282 2.112.97l5.617 5.617v.001h.002zM21.625 7.5a1 1 0 100 2h.019a1 1 0 100-2h-.019z" _fill="#A4AAB6"/>'
  }
})
